import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getReports } from "../services/reportsService";
import { getJobs } from "../services/jobsService";
import { getApplications } from "../services/applicationsService";
import { isSupabaseConfigured } from "../supabase/client";

const Dashboard = () => {
  const [counts, setCounts] = useState({ reports: null, jobs: null, newApps: null });
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!isSupabaseConfigured) return;
    (async () => {
      try {
        const [reports, jobs, apps] = await Promise.all([getReports(), getJobs(), getApplications()]);
        setCounts({
          reports: reports.length,
          jobs: jobs.filter((j) => j.active).length,
          newApps: apps.filter((a) => (a.status || "new") === "new").length,
        });
      } catch (e) {
        setErr(true);
      }
    })();
  }, []);

  return (
    <>
      <div className="admin-topbar">
        <h2>Dashboard</h2>
        <a className="view-site" href="/" target="_blank" rel="noopener noreferrer">
          View site ↗
        </a>
      </div>

      <div className="admin-content">
        {!isSupabaseConfigured && (
          <div className="config-warning">
            Supabase isn't configured yet — content counts and editing will work
            once your keys are added to <code>.env</code>.
          </div>
        )}
        {err && (
          <div className="admin-alert error">
            Couldn't load data. Check your Supabase config & policies.
          </div>
        )}

        <div className="dash-grid">
          <Link className="dash-card" to="/admin/reports">
            <div className="ico">▤</div>
            <div className="count">{counts.reports ?? "—"}</div>
            <h3>Management Reports</h3>
            <p>Add, edit, or remove quarterly reports.</p>
          </Link>

          <Link className="dash-card" to="/admin/jobs">
            <div className="ico">▧</div>
            <div className="count">{counts.jobs ?? "—"}</div>
            <h3>Open Positions</h3>
            <p>Post and manage job openings.</p>
          </Link>

          <Link className="dash-card" to="/admin/applications">
            <div className="ico">▦</div>
            <div className="count">{counts.newApps ?? "—"}</div>
            <h3>New Applications</h3>
            <p>Review candidates and download resumes.</p>
          </Link>

          <Link className="dash-card" to="/admin/contact">
            <div className="ico">▨</div>
            <div className="count">&nbsp;</div>
            <h3>Contact Info</h3>
            <p>Offices, emails, phones, and social links.</p>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
